import React from 'react';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';

import { NFTType } from '@webapp/pages/catalog/nft-tab';
import { formatNumber } from '@webapp/pages/earnings';

interface NFTMobileInfoRowProps {
  item: NFTType;
}

export default function NFTMobileInfoRow({ item }: NFTMobileInfoRowProps) {
  return (
    <Wrapper>
      <Flex justifyContent="space-between" alignItems="center" gap={10}>
        <Typography weight="700">
          <Translate id="CATALOG.MERCH.HEADER.QUANTITY" />
        </Typography>
        <Typography type="small">{formatNumber(item.qty)}</Typography>
      </Flex>
      <Flex justifyContent="space-between" alignItems="center" gap={10}>
        <Typography weight="700">
          <Translate id="CATALOG.MERCH.HEADER.OWNERSHIP" />
        </Typography>
        <Typography type="small">{item.owenership}</Typography>
      </Flex>
      <Flex justifyContent="space-between" alignItems="center" gap={10}>
        <Typography weight="700">
          <Translate id="CATALOG.MERCH.HEADER.STAKEHOLDERS" />
        </Typography>
        <Typography type="small">{item.stakeholders}</Typography>
      </Flex>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: grid;
  grid-gap: 10px;
`;
